<template>
  <div class="CitasComponente">
    <md-card>
      <md-card-header>
        <md-card-header-text>
          <div class="md-title">Citas</div>
        </md-card-header-text>
        <md-button
          v-if="$session.get('tipo') != 'otro'"
          class="md-icon-button md-raised md-primary"
          @click="dialogCitaForm = true"
        >
          <md-icon>add</md-icon>
        </md-button>
      </md-card-header>
      <md-list class="md-double-line">
        <div
          v-for="(item,index) in citas"
          :key="index"
        >
          <md-list-item>
            <md-icon :class="item.estatus_cit"></md-icon>
            <div class="md-list-item-text">
              <span class="upper">{{$moment(item.fecha_cit + ' '+item.hora_cit).format('LLLL')}}</span>
              <span class="upper">{{item.estatus_cit}}</span>
            </div>
            <div v-if="$session.get('tipo') != 'otro'">
              <md-button
                v-if="item.estatus_cit != 'cancelada'"
                class="md-icon-button md-list-action"
                @click="_editar(item,index)"
              >
                <md-icon class="md-primary">edit</md-icon>
              </md-button>
            </div>
          </md-list-item>
          <md-divider v-if="index + 1 < citas.length" />
        </div>
      </md-list>
    </md-card>
    <Loading v-if="cargando" />

    <md-dialog :md-active.sync="dialogCitaForm">
      <md-dialog-title>{{cita.id ? 'Actualizar' : 'Agregar'}} cita</md-dialog-title>
      <md-dialog-content>
        <md-datepicker
          v-model="cita.fecha_cit"
          :class="errores.fecha_cit"
          md-immediately
        >
          <label>Fecha</label>
        </md-datepicker>
        <md-field :class="errores.hora_cit">
          <label>Hora</label>
          <md-select
            v-model="cita.hora_cit"
            md-dense
            required
          >
            <md-option value="07:00:00">7 AM</md-option>
            <md-option value="08:00:00">8 AM</md-option>
            <md-option value="09:00:00">9 AM</md-option>
            <md-option value="10:00:00">10 AM</md-option>
            <md-option value="11:00:00">11 AM</md-option>
            <md-option value="12:00:00">12 PM</md-option>
            <md-option value="13:00:00">1 PM</md-option>
            <md-option value="14:00:00">2 PM</md-option>
            <md-option value="15:00:00">3 PM</md-option>
            <md-option value="16:00:00">4 PM</md-option>
            <md-option value="17:00:00">5 PM</md-option>
            <md-option value="18:00:00">6 PM</md-option>
            <md-option value="19:00:00">7 PM</md-option>
            <md-option value="20:00:00">8 PM</md-option>
          </md-select>
        </md-field>
        <md-field>
          <label>Estatus</label>
          <md-select
            v-model="cita.estatus_cit"
            md-dense
            required
          >
            <md-option value="programada">Programada</md-option>
            <md-option value="confirmada">Confirmada</md-option>
            <md-option value="atendida">Atendida</md-option>
            <md-option value="cancelada">Cancelada</md-option>
          </md-select>
        </md-field>
        <div v-if="cita.estatus_cit === 'atendida'">
          <md-field>
            <label>Padres sensibilizados</label>
            <md-input
              v-model="cita.padres_cit"
              type="number"
              min="0"
              required
            />
          </md-field>
          <md-field>
            <label>Alumnos registrados</label>
            <md-input
              v-model="cita.alumnos_cit"
              type="number"
              min="0"
              required
            />
            <span class="md-helper-text">Numero de niños inscritos en los grados tamizados</span>
          </md-field>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click="dialogCitaForm=false">Cancelar</md-button>
        <md-button
          @click="_presave()"
          class="md-raised md-primary"
        > {{cita.id ? 'Actualizar' : 'Guardar'}} </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import Loading from "@/components/Loading";
export default {
  name: "CitasComponente",
  props: {
    escuela: Object
  },
  components: { Loading },
  methods: {
    _validar() {
      this.errores.fecha_cit = this.$mdError(this.cita.fecha_cit);
      this.errores.hora_cit = this.$mdError(this.cita.hora_cit);
      this.errores.estatus_cit = this.$mdError(this.cita.estatus_cit);
      return this.$validate(this.errores);
    },
    _presave() {
      if (this._validar()) {
        this.cita.id ? this._actualizar() : this._guardar();
      } else {
        this.$emit("msg", this.$llene_campos);
      }
    },
    _guardar() {
      this.cargando = true;
      let idTemporal = "c." + this.$moment();
      let fechaFormat = this.$moment(this.cita.fecha_cit).format("YYYY-MM-DD");
      this.citas.unshift({
        id: idTemporal,
        id_esc_cit: this.escuela.id_esc,
        fecha_cit: fechaFormat,
        hora_cit: this.cita.hora_cit,
        padres_cit: this.cita.padres_cit,
        alumnos_cit: this.cita.alumnos_cit,
        estatus_cit: this.cita.estatus_cit,
        start: fechaFormat + " " + this.cita.hora_cit,
        end: fechaFormat + " " + this.cita.hora_cit,
        title: this.escuela.nombre_esc,
        content: this.cita.estatus_cit.toUpperCase(),
        class: this.cita.estatus_cit
      });
      this.$emit("msg", "Cita guardada");
      this.dialogCitaForm = false;
      this.cargando = false;
      this._guardarECIT();
    },
    _editar(a) {
      this.cita.id = a.id;
      this.cita.id_cit = a.id_cit;
      this.cita.fecha_cit = a.fecha_cit;
      this.cita.hora_cit = a.hora_cit;
      this.cita.estatus_cit = a.estatus_cit;
      this.cita.padres_cit = a.padres_cit;
      this.cita.alumnos_cit = a.alumnos_cit;
      this.dialogCitaForm = true;
    },
    _actualizar() {
      let fechaFormat = this.$moment(this.cita.fecha_cit).format("YYYY-MM-DD");
      let id = this.cita.id;
      let ix = this.citas.findIndex(function(b) {
        return b.id === id;
      });
      if (ix >= 0) {
        let idc =
          this.cita.id.charAt(1) === "." ? this.cita.id : "u." + this.cita.id;
        this.citas[ix].id = idc;
        this.citas[ix].fecha_cit = this.cita.fecha_cit;
        this.citas[ix].hora_cit = this.cita.hora_cit;
        this.citas[ix].estatus_cit = this.cita.estatus_cit;
        this.citas[ix].padres_cit = this.cita.padres_cit;
        this.citas[ix].alumnos_cit = this.cita.alumnos_cit;
        this.citas[ix].start = fechaFormat + " " + this.cita.hora_cit;
        this.citas[ix].end = fechaFormat + " " + this.cita.hora_cit;
        this.citas[ix].content = this.cita.estatus_cit.toUpperCase();
        this.citas[ix].class = this.cita.estatus_cit;
        this.$emit("msg", "Cita actualizada");
        this.dialogCitaForm = false;
        this._guardarECIT();
      }
    },
    _guardarECIT() {
      this.e_cit[this.indexECO].escuelas_citas = this.citas;
      localStorage.setItem("escuelas_citas", JSON.stringify(this.e_cit));
    }
  },
  data() {
    return {
      buscar: null,
      dialogCitaForm: false,
      citas: [],
      cita: {
        id: null,
        id_cit: null,
        id_esc_cit: null,
        fecha_cit: null,
        hora_cit: null,
        estatus_cit: null,
        padres_cit: 0,
        alumnos_cit: 0
      },
      errores: {
        id: null,
        id_cit: null,
        id_esc_cit: null,
        fecha_cit: null,
        hora_cit: null,
        estatus_cit: null,
        padres_cit: 0,
        alumnos_cit: 0
      },
      cargando: false,
      e_cit: [],
      indexECO: null
    };
  },
  watch: {
    e_cit(aa) {
      let idEscuela = this.$route.params.idEscuela;
      this.indexECO = aa.findIndex(function(b) {
        return b.escuela === idEscuela;
      });
      if (this.indexECO < 0) {
        this.e_cit.push({ escuela: idEscuela, escuelas_citas: [] });
        this.indexECO = this.e_cit.length - 1;
      }
    },
    indexECO(a) {
      if (a >= 0) {
        this.citas = this.e_cit[a].escuelas_citas;
      } else {
        this.contactos = [];
      }
    },
    dialogCitaForm(a) {
      if (!a) {
        this.cita.id = null;
        this.errores.id = null;
        this.cita.id_cit = null;
        this.errores.id_cit = null;
        this.cita.id_esc_cit = null;
        this.errores.id_esc_cit = null;
        this.cita.fecha_cit = null;
        this.errores.fecha_cit = null;
        this.cita.hora_cit = null;
        this.errores.hora_cit = null;
        this.cita.estatus_cit = null;
        this.errores.estatus_cit = null;
      }
    }
  },
  created() {
    let idEsc = this.$route.params.idEscuela;
    if (localStorage.getItem("escuelas_citas")) {
      this.e_cit = JSON.parse(localStorage.getItem("escuelas_citas"));
    } else {
      let sett = [{ escuela: idEsc, escuelas_citas: [] }];
      localStorage.setItem("escuelas_citas", JSON.stringify(sett));
      this.e_cit = JSON.parse(localStorage.getItem("escuelas_citas"));
    }
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$emit("visible", false);
      this.$router.push("/login");
    } else {
      this.$emit("visible", true);
      this.$emit("classes", "container");
    }
  },
  beforeDestroy() {
    this._guardarECIT();
  }
};
</script>